module.exports = __webpack_public_path__ + "static/media/overpass-extralight-italic.85914371.woff2";